import { DropdownMenuLabel } from "components/common/dropdown/DropDownV2";
import { cn } from "utils/cn";

type DropdownSectionLabelProps = {
  children: string;
  trailing?: string;
  className?: string;
};

export const DropdownSectionLabel = ({
  children,
  trailing,
  className,
}: DropdownSectionLabelProps) => (
  <DropdownMenuLabel
    className={cn(
      "flex items-center justify-between px-2 py-1.5 text-xs font-medium text-muted-foreground",
      className
    )}
  >
    <span>{children}</span>
    {trailing ? <span className="font-normal text-muted-foreground/70">{trailing}</span> : null}
  </DropdownMenuLabel>
);
